import { ArrowRight } from "lucide-react";
import type { SingleLinkComponent } from "../../types";
import { GuardedLink } from "../../runtime/DevPlaceholder";

/** Single link renderer. Default is an inline underlined link; `variant: "button"`
 *  renders a rounded pill (accent yellow, or brand blue with `color: "blue"`) —
 *  used for standalone CTAs like "La méthode TRIE". Non-connected destinations
 *  open the dev modal in preview and are hidden in production (GuardedLink). */
export function SingleLinkRenderer({ component }: { component: SingleLinkComponent }) {
  const { href, label, variant = "link", color = "yellow" } = component.content;

  if (variant === "button") {
    const isBlue = color === "blue";
    return (
      // The page wrapper gives SingleLink no top margin (mt-0) so inline link
      // variants hug the preceding text; the button variant needs breathing
      // room so the pill isn't stuck to the paragraph above it.
      <section className="mt-6 md:mt-8">
        <GuardedLink
          href={href}
          label={label}
          className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm xl:text-base font-semibold transition hover:opacity-90 ${
            isBlue ? "bg-[#005CA9] text-white" : "bg-[#F9A21B] text-white"
          }`}
        >
          {label}
          <ArrowRight className="h-4 w-4 shrink-0" />
        </GuardedLink>
      </section>
    );
  }

  return (
    <section>
      <div className="mt-3 text-sm xl:text-base md:text-base">
        <GuardedLink href={href} label={label} className="inline-flex items-center gap-2 text-[#005CA9] underline">
          {label}
          <span aria-hidden="true">↗</span>
        </GuardedLink>
      </div>
    </section>
  );
}
